require('./general');
require('./pdf');



// WEBPACK FOOTER //
// ./resources/assets/js/regular/index.js